import React from "react";

import DOMPurify from "dompurify";
import "./DescriptionContent.scss";

function DescriptionContent(content,language) {
  return content ? <p dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(content[language])}}></p> : <></>;
}

export default DescriptionContent;